import * as yup from 'yup'
import { judgeOpts } from '@ow/utils'

export default function (opts, fields, data, refConditonFields) {
  let finalOpts = {}
  console.log(
    refConditonFields,
    refConditonFields[opts.slug],
    opts,
    'refControl'
  )
  if (opts.logicSpec && refConditonFields[opts.slug]) {
    // 添加监听
    const logicFields = opts.logicSpec.conditions.map((x) => x.slug)
    console.log(refConditonFields[opts.slug], logicFields, 'logicFields')
    finalOpts = judgeOpts({
      opts,
      values: refConditonFields[opts.slug],
      fields,
      defaultValues: data,
    })
    console.log(finalOpts, 'finalOpts')
  } else {
    finalOpts = opts
  }
  const { required } = finalOpts

  let schema = yup.string().nullable()
  if (required) {
    schema = schema.required('这是一个必填项')
  }

  return schema
}
